import { render, staticRenderFns } from "./ExpressCreation.vue?vue&type=template&id=561c106d&"
import script from "./ExpressCreation.vue?vue&type=script&lang=js&"
export * from "./ExpressCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports